app.controller('EmployeeNewExternalDocumentController', ['$scope', '$uibModal', '$stateParams', 'AuthService', 'StaticData', 'DocumentsService', '$http', 'usSpinnerService', 'toastr', '$state', '$rootScope', 'Hr',
    function ($scope, $uibModal, $stateParams, AuthService, StaticData, DocumentsService, $http, usSpinnerService, toastr, $state, $rootScope, Hr) {
        $scope.isRoot = false;
        $scope.format = "dd-MM-yyyy";
        $scope.documentTypes = {
            'OUTER': [],
            'OUTGOING': []
        };
        $scope.senderTypes = [
            { name: 'ორგანიზაცია', value: 'ORGANISATION' },
            { name: 'კერძო პირი', value: 'PERSON' }
        ];
        $scope.type = null;
        $scope.senderType = null;
        $scope.documentAddressees = {
            'UNIT': [],
            'PERSON': []
        };
        $scope.senders = [];
        $scope.senderNameInput = '';
        $scope.senderIdInput = '';
        $scope.addresseeType = null;
        $scope.text = '';
        $scope.comment = '';
        $scope.topic = '';
        $scope.resolutionComment = '';
        $scope.addressees = [];
        $scope.addressee = [];
        $scope.attachments = [];
        $scope.infos = [];
        $scope.author = null;
        $scope.sheetsNumber = '';
        $scope.pickerPopup = { opened: false };
        $scope.action = 'create';
        $scope.isForStudent = null;
        $scope.basisFileNumber = null;
        $scope.basisFile = null;
        $scope.basisFiles = [];
        $scope.deadLine = null;
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            startingDay: 1
        };
        $scope.popup1 = {
            opened: false
        };
        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };
        $scope.popupDateGenerated = {
            opened: false
        };
        $scope.openDateGeneratedPopup = function () {
            $scope.popupDateGenerated.opened = true;
        };

        AuthService.getUserData().then(function (user) {
            $scope.profile = user.profiles.filter(function (p) {
                return p.type === "employee" && p.state === 'active'
            })[0];

            if ($scope.profile.positionInfo) {
                AuthService.isRoot = $scope.profile.positionInfo.isRoot;
                $scope.isRoot = AuthService.isRoot;
            }
        });

        DocumentsService.typeList({ admin: true }).then(function (data) {
            data.forEach(function (type) {
                if (type.parentId === 'OUTER') {
                    $scope.documentTypes[type.parentId].push(type);
                }
            });

        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        DocumentsService.getDocumentAddresseeExternal().then(function (data) {
            data.forEach(function (addressee) {
                if (addressee.isUnit)
                    $scope.documentAddressees['UNIT'].push(addressee);
                else
                    $scope.documentAddressees['PERSON'].push(addressee);

            });

        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.deleteAddressee = function (id) {
            var el_index = _.findIndex($scope.addressees, function (addr) {
                return id === addr._id;
            });

            $scope.addressees.splice(el_index, 1);
        };

        $scope.send = function () {
            if (!$scope.topic) toastr.error('', 'გთხოვთ მიუთითოთ თემატიკა');
            else if (!$scope.type) toastr.error('', 'გთხოვთ მიუთითოთ დოკუმენტის ტიპი');
            else if (!$scope.senderType) toastr.error('', 'გთხოვთ მიუთითოთ გამომგზავნის ტიპი');
            else if (!$scope.addressees.length && !$scope.addresseeType) toastr.error('', 'გთხოვთ მიუთითოთ ადრესატი');
            else if (!$scope.comment) toastr.error('', 'გთხოვთ მიუთითოთ კომენტარი');
            else if (!$scope.senders.length) toastr.error('', 'გთხოვთ მიუთითოთ გამომგზავნი');
            else if ($scope.basisFiles.length !== 1) toastr.error('', 'გთხოვთ დაურთოთ დოკუმენტი ფაილად');
            else {
                usSpinnerService.spin("root");
                DocumentsService.register({
                    type: $scope.type,
                    text: $scope.text,
                    comment: $scope.comment,
                    topic: $scope.topic,
                    senderType: $scope.senderType,
                    addressees: $scope.addressees.map(function (item) {
                        var addressee;
                        if (item.isUnit) {
                            addressee = item;
                            addressee.info = { _id: item._id };
                        } else {
                            addressee = _.omit(item, 'profile');
                            addressee.info = { _id: item.profile._id };
                        }

                        return addressee;
                    }),
                    senders: $scope.senders,
                    addresseeType: $scope.addresseeType,
                    attachments: $scope.attachments,
                    documentNumber: $scope.documentNumber,
                    documentDate: $scope.documentDate,
                    documentFile: $scope.basisFiles[0]._id,
                    sheetsNumber: $scope.sheetsNumber,
                    deadline: $scope.deadLine
                }).then(function () {
                    usSpinnerService.spin("root");
                    toastr.success('', 'დოკუმენტი გაგზავნილია');
                    $rootScope.documentsCount();
                    $state.go('employee.documents.external');
                }).catch(function () {
                    usSpinnerService.spin("root");
                    toastr.error('', 'დოკუმენტის გაგზავნისას დაფიქსირდა შეცდომა');
                })
            }
        };

        $scope.uploadAttachment = function (type, files) {
            usSpinnerService.spin("root");
            $scope.file = files[0];
            var fd = new FormData();
            if ($scope.file && $scope.file.name) {
                fd.append('file', $scope.file, $scope.file.name);
                $http.post('/documents/attachments', fd, {
                    headers: { 'Content-Type': undefined }
                }).then(function (response) {
                    if (type === 'basis') {
                        $scope.basisFiles.push(response.data);
                        $scope.fileName = response.data.name;
                    } else if (type === 'attachment') {
                        $scope.attachments.push(response.data);
                        $scope.fileName = response.data.name;
                    }
                    usSpinnerService.stop("root");
                })
            }
        };

        $scope.removeAttachment = function (type, file) {
            usSpinnerService.spin("root");
            if (type === 'basis' && !file.location) {
                for (var i in $scope.basisFiles) {
                    if (!$scope.basisFiles[i].location && file.name === $scope.basisFiles[i].name) {
                        $scope.basisFiles.splice(i, 1);
                        usSpinnerService.stop("root");
                    }
                }
            } else if (file.location) {
                DocumentsService.removeAttachment(file._id).then(function () {
                    var elementIndex;
                    if (type === 'basis') {
                        elementIndex = _.findIndex($scope.basisFiles, function (basisFile) {
                            return basisFile._id === file._id;
                        });
                        $scope.basisFiles.splice(elementIndex, 1);
                    }
                    if (type === 'attachment') {
                        elementIndex = _.findIndex($scope.attachments, function (attachmentFile) {
                            return attachmentFile._id === file._id;
                        });
                        $scope.attachments.splice(elementIndex, 1);
                    }
                    usSpinnerService.stop("root");
                })
            } else {
                usSpinnerService.stop("root");
            }
        };

        $scope.setAddresseeAsVisior = function (addressee) {
            $scope.addressees = $scope.addressees.map(function (a) {
                if (addressee.profile._id === a.profile._id) {
                    a.type = addressee.visior ? 'visa' : null
                }
                return a;
            })
            $scope.addressees = _.sortBy($scope.addressees, 'type');
        };

        $scope.addToAddresseeList = function () {
            if ($scope.addressee) {
                const addressee = $scope.addressee;
                if ($scope.addressees.indexOf(addressee) > -1) {
                    toastr.error('', 'ადრესატი უკვე დამატებულია');
                } else {
                    usSpinnerService.spin("root");
                    Hr.getCurrentVacation(addressee.profile._id).then(function (res) {
                        if (res.vacation) {
                            //todo check vacation
                            addressee.vacation = res.vacation;
                            addressee.performer = res.performer;
                        }
                        $scope.addressees.push(addressee);
                        usSpinnerService.stop("root");
                    });
                }
                $scope.addressee = null;
            }
        };

        $scope.attachmentRequired = function () {
            for (var i in $scope.documentTypes) {
                var filtered = $scope.documentTypes[i].filter(function (el) {
                    return el._id === $scope.type
                });
                if (filtered.length > 0) {
                    return filtered[0].attachmentRequired || false;
                }
            }
            return false;
        }

        $scope.addSender = function () {
            $scope.senders.push({
                name: $scope.senderNameInput,
                id: $scope.senderIdInput
            });
            $scope.senderNameInput = '';
            $scope.senderIdInput = '';
        };

        $scope.removeSender = function (sender) {
            $scope.senders = $scope.senders.filter(function (currentSender) {
                return sender.id !== currentSender.id;
            });
        };

        $scope.getSenders = function (query) {
            if (query.length < 2) {
                return [];
            }
            return DocumentsService.sendersList({ query: query });
        };

        $scope.setSenderNameAndId = function ($item) {
            $scope.senderIdInput = $item.id;
            $scope.senderNameInput = $item.name;
        }

    }]);
